import { default as bannersIHpYd1SbB3Meta } from "/opt/atlassian/pipelines/agent/build/pages/admin/banners.vue?macro=true";
import { default as call_45centerDHvD9j189uMeta } from "/opt/atlassian/pipelines/agent/build/pages/admin/call-center.vue?macro=true";
import { default as clients4swfDZeOEjMeta } from "/opt/atlassian/pipelines/agent/build/pages/admin/clients.vue?macro=true";
import { default as feedbacksLin48df0u9Meta } from "/opt/atlassian/pipelines/agent/build/pages/admin/feedbacks.vue?macro=true";
import { default as indexOw8xB7VBqUMeta } from "/opt/atlassian/pipelines/agent/build/pages/admin/index.vue?macro=true";
import { default as indexlqlWuQcq5gMeta } from "/opt/atlassian/pipelines/agent/build/pages/admin/orders/index.vue?macro=true";
import { default as _91id_93RR5tgTQFzTMeta } from "/opt/atlassian/pipelines/agent/build/pages/admin/orders/negotiation-room/[id].vue?macro=true";
import { default as indexuqTU7LSWegMeta } from "/opt/atlassian/pipelines/agent/build/pages/admin/orders/reprocess/index.vue?macro=true";
import { default as indextcQ4zx3xfyMeta } from "/opt/atlassian/pipelines/agent/build/pages/admin/orders/status/index.vue?macro=true";
import { default as salesqkEdJVwYaHMeta } from "/opt/atlassian/pipelines/agent/build/pages/admin/sales.vue?macro=true";
import { default as addressT4RaiZ6lnEMeta } from "/opt/atlassian/pipelines/agent/build/pages/checkout/address.vue?macro=true";
import { default as informationGZ4MPo5kNiMeta } from "/opt/atlassian/pipelines/agent/build/pages/checkout/information.vue?macro=true";
import { default as orders4FaQGvRYrUMeta } from "/opt/atlassian/pipelines/agent/build/pages/checkout/orders.vue?macro=true";
import { default as paymentW0c4W75UiHMeta } from "/opt/atlassian/pipelines/agent/build/pages/checkout/payment.vue?macro=true";
import { default as personal_45dataBSxHek1VN1Meta } from "/opt/atlassian/pipelines/agent/build/pages/checkout/personal-data.vue?macro=true";
import { default as pixRJNNnD2X4aMeta } from "/opt/atlassian/pipelines/agent/build/pages/checkout/pix.vue?macro=true";
import { default as reentrancec4jjYdUAXJMeta } from "/opt/atlassian/pipelines/agent/build/pages/checkout/reentrance.vue?macro=true";
import { default as subscriptionXlTPMl2awNMeta } from "/opt/atlassian/pipelines/agent/build/pages/checkout/subscription.vue?macro=true";
import { default as voucherYFwwohDATgMeta } from "/opt/atlassian/pipelines/agent/build/pages/checkout/voucher.vue?macro=true";
import { default as _91id_93xJCtwBYB0tMeta } from "/opt/atlassian/pipelines/agent/build/pages/cursos/[id].vue?macro=true";
import { default as errorRA6q6dlwuUMeta } from "/opt/atlassian/pipelines/agent/build/pages/error.vue?macro=true";
import { default as indexOD9t3F2bSJMeta } from "/opt/atlassian/pipelines/agent/build/pages/index.vue?macro=true";
import { default as _91slug_93xJ7O5lBoG5Meta } from "/opt/atlassian/pipelines/agent/build/pages/instituicao/[slug].vue?macro=true";
import { default as carta_45de_45apresentacaoHGrLsSJRn4Meta } from "/opt/atlassian/pipelines/agent/build/pages/lp/anima/carta-de-apresentacao.vue?macro=true";
import { default as index1ne0kT4ob8Meta } from "/opt/atlassian/pipelines/agent/build/pages/lp/anima/index.vue?macro=true";
import { default as cogna78znObN3uJMeta } from "/opt/atlassian/pipelines/agent/build/pages/lp/cogna.vue?macro=true";
import { default as estacioh6ybjDOkaMMeta } from "/opt/atlassian/pipelines/agent/build/pages/lp/estacio.vue?macro=true";
import { default as loginFxW97BjNkVMeta } from "/opt/atlassian/pipelines/agent/build/pages/minha-area/login.vue?macro=true";
import { default as pedidos59lebwH2D6Meta } from "/opt/atlassian/pipelines/agent/build/pages/minha-area/pedidos.vue?macro=true";
import { default as retornoVqtiQ2coLIMeta } from "/opt/atlassian/pipelines/agent/build/pages/minha-area/retorno.vue?macro=true";
import { default as politica_45de_45bolsa_45anima6oMnLbfQ7rMeta } from "/opt/atlassian/pipelines/agent/build/pages/politica-de-bolsa-anima.vue?macro=true";
import { default as politica_45de_45privacidadewqW8CSU8pmMeta } from "/opt/atlassian/pipelines/agent/build/pages/politica-de-privacidade.vue?macro=true";
import { default as _91slug_93Ho2nH9AUZqMeta } from "/opt/atlassian/pipelines/agent/build/pages/produto/[slug].vue?macro=true";
import { default as blackfridaygzWriY2U0aMeta } from "/opt/atlassian/pipelines/agent/build/pages/promo/blackfriday.vue?macro=true";
import { default as indexg4I7XhGA6hMeta } from "/opt/atlassian/pipelines/agent/build/pages/promo/index.vue?macro=true";
import { default as passwordUkCPOcgd1wMeta } from "/opt/atlassian/pipelines/agent/build/pages/recover/password.vue?macro=true";
import { default as reembolso0tYpQ4ohY8Meta } from "/opt/atlassian/pipelines/agent/build/pages/reembolso.vue?macro=true";
import { default as sobre_45o_45vaidebolsaReQ3RBCeefMeta } from "/opt/atlassian/pipelines/agent/build/pages/sobre-o-vaidebolsa.vue?macro=true";
import { default as termos_45de_45uso_45e_45politica_45de_45reembolsoGI6RMfmYA7Meta } from "/opt/atlassian/pipelines/agent/build/pages/termos-de-uso-e-politica-de-reembolso.vue?macro=true";
import { default as inscricao_45animaEgeP5swvs2Meta } from "/opt/atlassian/pipelines/agent/build/pages/widget/inscricao-anima.vue?macro=true";
import { default as inscricao_45estaciohsXhekkxV3Meta } from "/opt/atlassian/pipelines/agent/build/pages/widget/inscricao-estacio.vue?macro=true";
import { default as instituicao47f8mgRv3yMeta } from "/opt/atlassian/pipelines/agent/build/pages/widget/instituicao.vue?macro=true";
import { default as slider_45institutionsGiaC6pHVogMeta } from "/opt/atlassian/pipelines/agent/build/pages/widget/slider-institutions.vue?macro=true";
import { default as todas_45marcasYdRrSEdWaaMeta } from "/opt/atlassian/pipelines/agent/build/pages/widget/todas-marcas.vue?macro=true";
export default [
  {
    name: bannersIHpYd1SbB3Meta?.name ?? "admin-banners",
    path: bannersIHpYd1SbB3Meta?.path ?? "/admin/banners",
    children: [],
    meta: bannersIHpYd1SbB3Meta,
    alias: bannersIHpYd1SbB3Meta?.alias || [],
    redirect: bannersIHpYd1SbB3Meta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/admin/banners.vue").then(m => m.default || m)
  },
  {
    name: call_45centerDHvD9j189uMeta?.name ?? "admin-call-center",
    path: call_45centerDHvD9j189uMeta?.path ?? "/admin/call-center",
    children: [],
    meta: call_45centerDHvD9j189uMeta,
    alias: call_45centerDHvD9j189uMeta?.alias || [],
    redirect: call_45centerDHvD9j189uMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/admin/call-center.vue").then(m => m.default || m)
  },
  {
    name: clients4swfDZeOEjMeta?.name ?? "admin-clients",
    path: clients4swfDZeOEjMeta?.path ?? "/admin/clients",
    children: [],
    meta: clients4swfDZeOEjMeta,
    alias: clients4swfDZeOEjMeta?.alias || [],
    redirect: clients4swfDZeOEjMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/admin/clients.vue").then(m => m.default || m)
  },
  {
    name: feedbacksLin48df0u9Meta?.name ?? "admin-feedbacks",
    path: feedbacksLin48df0u9Meta?.path ?? "/admin/feedbacks",
    children: [],
    meta: feedbacksLin48df0u9Meta,
    alias: feedbacksLin48df0u9Meta?.alias || [],
    redirect: feedbacksLin48df0u9Meta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/admin/feedbacks.vue").then(m => m.default || m)
  },
  {
    name: indexOw8xB7VBqUMeta?.name ?? "admin",
    path: indexOw8xB7VBqUMeta?.path ?? "/admin",
    children: [],
    meta: indexOw8xB7VBqUMeta,
    alias: indexOw8xB7VBqUMeta?.alias || [],
    redirect: indexOw8xB7VBqUMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/admin/index.vue").then(m => m.default || m)
  },
  {
    name: indexlqlWuQcq5gMeta?.name ?? "admin-orders",
    path: indexlqlWuQcq5gMeta?.path ?? "/admin/orders",
    children: [],
    meta: indexlqlWuQcq5gMeta,
    alias: indexlqlWuQcq5gMeta?.alias || [],
    redirect: indexlqlWuQcq5gMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/admin/orders/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93RR5tgTQFzTMeta?.name ?? "admin-orders-negotiation-room-id",
    path: _91id_93RR5tgTQFzTMeta?.path ?? "/admin/orders/negotiation-room/:id",
    children: [],
    meta: _91id_93RR5tgTQFzTMeta,
    alias: _91id_93RR5tgTQFzTMeta?.alias || [],
    redirect: _91id_93RR5tgTQFzTMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/admin/orders/negotiation-room/[id].vue").then(m => m.default || m)
  },
  {
    name: indexuqTU7LSWegMeta?.name ?? "admin-orders-reprocess",
    path: indexuqTU7LSWegMeta?.path ?? "/admin/orders/reprocess",
    children: [],
    meta: indexuqTU7LSWegMeta,
    alias: indexuqTU7LSWegMeta?.alias || [],
    redirect: indexuqTU7LSWegMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/admin/orders/reprocess/index.vue").then(m => m.default || m)
  },
  {
    name: indextcQ4zx3xfyMeta?.name ?? "admin-orders-status",
    path: indextcQ4zx3xfyMeta?.path ?? "/admin/orders/status",
    children: [],
    meta: indextcQ4zx3xfyMeta,
    alias: indextcQ4zx3xfyMeta?.alias || [],
    redirect: indextcQ4zx3xfyMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/admin/orders/status/index.vue").then(m => m.default || m)
  },
  {
    name: salesqkEdJVwYaHMeta?.name ?? "admin-sales",
    path: salesqkEdJVwYaHMeta?.path ?? "/admin/sales",
    children: [],
    meta: salesqkEdJVwYaHMeta,
    alias: salesqkEdJVwYaHMeta?.alias || [],
    redirect: salesqkEdJVwYaHMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/admin/sales.vue").then(m => m.default || m)
  },
  {
    name: addressT4RaiZ6lnEMeta?.name ?? "checkout-address",
    path: addressT4RaiZ6lnEMeta?.path ?? "/checkout/address",
    children: [],
    meta: addressT4RaiZ6lnEMeta,
    alias: addressT4RaiZ6lnEMeta?.alias || [],
    redirect: addressT4RaiZ6lnEMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/checkout/address.vue").then(m => m.default || m)
  },
  {
    name: informationGZ4MPo5kNiMeta?.name ?? "checkout-information",
    path: informationGZ4MPo5kNiMeta?.path ?? "/checkout/information",
    children: [],
    meta: informationGZ4MPo5kNiMeta,
    alias: informationGZ4MPo5kNiMeta?.alias || [],
    redirect: informationGZ4MPo5kNiMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/checkout/information.vue").then(m => m.default || m)
  },
  {
    name: orders4FaQGvRYrUMeta?.name ?? "checkout-orders",
    path: orders4FaQGvRYrUMeta?.path ?? "/checkout/orders",
    children: [],
    meta: orders4FaQGvRYrUMeta,
    alias: orders4FaQGvRYrUMeta?.alias || [],
    redirect: orders4FaQGvRYrUMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/checkout/orders.vue").then(m => m.default || m)
  },
  {
    name: paymentW0c4W75UiHMeta?.name ?? "checkout-payment",
    path: paymentW0c4W75UiHMeta?.path ?? "/checkout/payment",
    children: [],
    meta: paymentW0c4W75UiHMeta,
    alias: paymentW0c4W75UiHMeta?.alias || [],
    redirect: paymentW0c4W75UiHMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/checkout/payment.vue").then(m => m.default || m)
  },
  {
    name: personal_45dataBSxHek1VN1Meta?.name ?? "checkout-personal-data",
    path: personal_45dataBSxHek1VN1Meta?.path ?? "/checkout/personal-data",
    children: [],
    meta: personal_45dataBSxHek1VN1Meta,
    alias: personal_45dataBSxHek1VN1Meta?.alias || [],
    redirect: personal_45dataBSxHek1VN1Meta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/checkout/personal-data.vue").then(m => m.default || m)
  },
  {
    name: pixRJNNnD2X4aMeta?.name ?? "checkout-pix",
    path: pixRJNNnD2X4aMeta?.path ?? "/checkout/pix",
    children: [],
    meta: pixRJNNnD2X4aMeta,
    alias: pixRJNNnD2X4aMeta?.alias || [],
    redirect: pixRJNNnD2X4aMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/checkout/pix.vue").then(m => m.default || m)
  },
  {
    name: reentrancec4jjYdUAXJMeta?.name ?? "checkout-reentrance",
    path: reentrancec4jjYdUAXJMeta?.path ?? "/checkout/reentrance",
    children: [],
    meta: reentrancec4jjYdUAXJMeta,
    alias: reentrancec4jjYdUAXJMeta?.alias || [],
    redirect: reentrancec4jjYdUAXJMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/checkout/reentrance.vue").then(m => m.default || m)
  },
  {
    name: subscriptionXlTPMl2awNMeta?.name ?? "checkout-subscription",
    path: subscriptionXlTPMl2awNMeta?.path ?? "/checkout/subscription",
    children: [],
    meta: subscriptionXlTPMl2awNMeta,
    alias: subscriptionXlTPMl2awNMeta?.alias || [],
    redirect: subscriptionXlTPMl2awNMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/checkout/subscription.vue").then(m => m.default || m)
  },
  {
    name: voucherYFwwohDATgMeta?.name ?? "checkout-voucher",
    path: voucherYFwwohDATgMeta?.path ?? "/checkout/voucher",
    children: [],
    meta: voucherYFwwohDATgMeta,
    alias: voucherYFwwohDATgMeta?.alias || [],
    redirect: voucherYFwwohDATgMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/checkout/voucher.vue").then(m => m.default || m)
  },
  {
    name: _91id_93xJCtwBYB0tMeta?.name ?? "cursos-id",
    path: _91id_93xJCtwBYB0tMeta?.path ?? "/cursos/:id",
    children: [],
    meta: _91id_93xJCtwBYB0tMeta,
    alias: _91id_93xJCtwBYB0tMeta?.alias || [],
    redirect: _91id_93xJCtwBYB0tMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/cursos/[id].vue").then(m => m.default || m)
  },
  {
    name: errorRA6q6dlwuUMeta?.name ?? "error",
    path: errorRA6q6dlwuUMeta?.path ?? "/error",
    children: [],
    meta: errorRA6q6dlwuUMeta,
    alias: errorRA6q6dlwuUMeta?.alias || [],
    redirect: errorRA6q6dlwuUMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/error.vue").then(m => m.default || m)
  },
  {
    name: indexOD9t3F2bSJMeta?.name ?? "index",
    path: indexOD9t3F2bSJMeta?.path ?? "/",
    children: [],
    meta: indexOD9t3F2bSJMeta,
    alias: indexOD9t3F2bSJMeta?.alias || [],
    redirect: indexOD9t3F2bSJMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/index.vue").then(m => m.default || m)
  },
  {
    name: _91slug_93xJ7O5lBoG5Meta?.name ?? "instituicao-slug",
    path: _91slug_93xJ7O5lBoG5Meta?.path ?? "/instituicao/:slug",
    children: [],
    meta: _91slug_93xJ7O5lBoG5Meta,
    alias: _91slug_93xJ7O5lBoG5Meta?.alias || [],
    redirect: _91slug_93xJ7O5lBoG5Meta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/instituicao/[slug].vue").then(m => m.default || m)
  },
  {
    name: carta_45de_45apresentacaoHGrLsSJRn4Meta?.name ?? "lp-anima-carta-de-apresentacao",
    path: carta_45de_45apresentacaoHGrLsSJRn4Meta?.path ?? "/lp/anima/carta-de-apresentacao",
    children: [],
    meta: carta_45de_45apresentacaoHGrLsSJRn4Meta,
    alias: carta_45de_45apresentacaoHGrLsSJRn4Meta?.alias || [],
    redirect: carta_45de_45apresentacaoHGrLsSJRn4Meta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/lp/anima/carta-de-apresentacao.vue").then(m => m.default || m)
  },
  {
    name: index1ne0kT4ob8Meta?.name ?? "lp-anima",
    path: index1ne0kT4ob8Meta?.path ?? "/lp/anima",
    children: [],
    meta: index1ne0kT4ob8Meta,
    alias: index1ne0kT4ob8Meta?.alias || [],
    redirect: index1ne0kT4ob8Meta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/lp/anima/index.vue").then(m => m.default || m)
  },
  {
    name: cogna78znObN3uJMeta?.name ?? "lp-cogna",
    path: cogna78znObN3uJMeta?.path ?? "/lp/cogna",
    children: [],
    meta: cogna78znObN3uJMeta,
    alias: cogna78znObN3uJMeta?.alias || [],
    redirect: cogna78znObN3uJMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/lp/cogna.vue").then(m => m.default || m)
  },
  {
    name: estacioh6ybjDOkaMMeta?.name ?? "lp-estacio",
    path: estacioh6ybjDOkaMMeta?.path ?? "/lp/estacio",
    children: [],
    meta: estacioh6ybjDOkaMMeta,
    alias: estacioh6ybjDOkaMMeta?.alias || [],
    redirect: estacioh6ybjDOkaMMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/lp/estacio.vue").then(m => m.default || m)
  },
  {
    name: loginFxW97BjNkVMeta?.name ?? "minha-area-login",
    path: loginFxW97BjNkVMeta?.path ?? "/minha-area/login",
    children: [],
    meta: loginFxW97BjNkVMeta,
    alias: loginFxW97BjNkVMeta?.alias || [],
    redirect: loginFxW97BjNkVMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/minha-area/login.vue").then(m => m.default || m)
  },
  {
    name: pedidos59lebwH2D6Meta?.name ?? "minha-area-pedidos",
    path: pedidos59lebwH2D6Meta?.path ?? "/minha-area/pedidos",
    children: [],
    meta: pedidos59lebwH2D6Meta,
    alias: pedidos59lebwH2D6Meta?.alias || [],
    redirect: pedidos59lebwH2D6Meta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/minha-area/pedidos.vue").then(m => m.default || m)
  },
  {
    name: retornoVqtiQ2coLIMeta?.name ?? "minha-area-retorno",
    path: retornoVqtiQ2coLIMeta?.path ?? "/minha-area/retorno",
    children: [],
    meta: retornoVqtiQ2coLIMeta,
    alias: retornoVqtiQ2coLIMeta?.alias || [],
    redirect: retornoVqtiQ2coLIMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/minha-area/retorno.vue").then(m => m.default || m)
  },
  {
    name: politica_45de_45bolsa_45anima6oMnLbfQ7rMeta?.name ?? "politica-de-bolsa-anima",
    path: politica_45de_45bolsa_45anima6oMnLbfQ7rMeta?.path ?? "/politica-de-bolsa-anima",
    children: [],
    meta: politica_45de_45bolsa_45anima6oMnLbfQ7rMeta,
    alias: politica_45de_45bolsa_45anima6oMnLbfQ7rMeta?.alias || [],
    redirect: politica_45de_45bolsa_45anima6oMnLbfQ7rMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/politica-de-bolsa-anima.vue").then(m => m.default || m)
  },
  {
    name: politica_45de_45privacidadewqW8CSU8pmMeta?.name ?? "politica-de-privacidade",
    path: politica_45de_45privacidadewqW8CSU8pmMeta?.path ?? "/politica-de-privacidade",
    children: [],
    meta: politica_45de_45privacidadewqW8CSU8pmMeta,
    alias: politica_45de_45privacidadewqW8CSU8pmMeta?.alias || [],
    redirect: politica_45de_45privacidadewqW8CSU8pmMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/politica-de-privacidade.vue").then(m => m.default || m)
  },
  {
    name: _91slug_93Ho2nH9AUZqMeta?.name ?? "produto-slug",
    path: _91slug_93Ho2nH9AUZqMeta?.path ?? "/produto/:slug",
    children: [],
    meta: _91slug_93Ho2nH9AUZqMeta,
    alias: _91slug_93Ho2nH9AUZqMeta?.alias || [],
    redirect: _91slug_93Ho2nH9AUZqMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/produto/[slug].vue").then(m => m.default || m)
  },
  {
    name: blackfridaygzWriY2U0aMeta?.name ?? "promo-blackfriday",
    path: blackfridaygzWriY2U0aMeta?.path ?? "/promo/blackfriday",
    children: [],
    meta: blackfridaygzWriY2U0aMeta,
    alias: blackfridaygzWriY2U0aMeta?.alias || [],
    redirect: blackfridaygzWriY2U0aMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/promo/blackfriday.vue").then(m => m.default || m)
  },
  {
    name: indexg4I7XhGA6hMeta?.name ?? "promo",
    path: indexg4I7XhGA6hMeta?.path ?? "/promo",
    children: [],
    meta: indexg4I7XhGA6hMeta,
    alias: indexg4I7XhGA6hMeta?.alias || [],
    redirect: indexg4I7XhGA6hMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/promo/index.vue").then(m => m.default || m)
  },
  {
    name: passwordUkCPOcgd1wMeta?.name ?? "recover-password",
    path: passwordUkCPOcgd1wMeta?.path ?? "/recover/password",
    children: [],
    meta: passwordUkCPOcgd1wMeta,
    alias: passwordUkCPOcgd1wMeta?.alias || [],
    redirect: passwordUkCPOcgd1wMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/recover/password.vue").then(m => m.default || m)
  },
  {
    name: reembolso0tYpQ4ohY8Meta?.name ?? "reembolso",
    path: reembolso0tYpQ4ohY8Meta?.path ?? "/reembolso",
    children: [],
    meta: reembolso0tYpQ4ohY8Meta,
    alias: reembolso0tYpQ4ohY8Meta?.alias || [],
    redirect: reembolso0tYpQ4ohY8Meta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/reembolso.vue").then(m => m.default || m)
  },
  {
    name: sobre_45o_45vaidebolsaReQ3RBCeefMeta?.name ?? "sobre-o-vaidebolsa",
    path: sobre_45o_45vaidebolsaReQ3RBCeefMeta?.path ?? "/sobre-o-vaidebolsa",
    children: [],
    meta: sobre_45o_45vaidebolsaReQ3RBCeefMeta,
    alias: sobre_45o_45vaidebolsaReQ3RBCeefMeta?.alias || [],
    redirect: sobre_45o_45vaidebolsaReQ3RBCeefMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/sobre-o-vaidebolsa.vue").then(m => m.default || m)
  },
  {
    name: termos_45de_45uso_45e_45politica_45de_45reembolsoGI6RMfmYA7Meta?.name ?? "termos-de-uso-e-politica-de-reembolso",
    path: termos_45de_45uso_45e_45politica_45de_45reembolsoGI6RMfmYA7Meta?.path ?? "/termos-de-uso-e-politica-de-reembolso",
    children: [],
    meta: termos_45de_45uso_45e_45politica_45de_45reembolsoGI6RMfmYA7Meta,
    alias: termos_45de_45uso_45e_45politica_45de_45reembolsoGI6RMfmYA7Meta?.alias || [],
    redirect: termos_45de_45uso_45e_45politica_45de_45reembolsoGI6RMfmYA7Meta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/termos-de-uso-e-politica-de-reembolso.vue").then(m => m.default || m)
  },
  {
    name: inscricao_45animaEgeP5swvs2Meta?.name ?? "widget-inscricao-anima",
    path: inscricao_45animaEgeP5swvs2Meta?.path ?? "/widget/inscricao-anima",
    children: [],
    meta: inscricao_45animaEgeP5swvs2Meta,
    alias: inscricao_45animaEgeP5swvs2Meta?.alias || [],
    redirect: inscricao_45animaEgeP5swvs2Meta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/widget/inscricao-anima.vue").then(m => m.default || m)
  },
  {
    name: inscricao_45estaciohsXhekkxV3Meta?.name ?? "widget-inscricao-estacio",
    path: inscricao_45estaciohsXhekkxV3Meta?.path ?? "/widget/inscricao-estacio",
    children: [],
    meta: inscricao_45estaciohsXhekkxV3Meta,
    alias: inscricao_45estaciohsXhekkxV3Meta?.alias || [],
    redirect: inscricao_45estaciohsXhekkxV3Meta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/widget/inscricao-estacio.vue").then(m => m.default || m)
  },
  {
    name: instituicao47f8mgRv3yMeta?.name ?? "widget-instituicao",
    path: instituicao47f8mgRv3yMeta?.path ?? "/widget/instituicao",
    children: [],
    meta: instituicao47f8mgRv3yMeta,
    alias: instituicao47f8mgRv3yMeta?.alias || [],
    redirect: instituicao47f8mgRv3yMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/widget/instituicao.vue").then(m => m.default || m)
  },
  {
    name: slider_45institutionsGiaC6pHVogMeta?.name ?? "widget-slider-institutions",
    path: slider_45institutionsGiaC6pHVogMeta?.path ?? "/widget/slider-institutions",
    children: [],
    meta: slider_45institutionsGiaC6pHVogMeta,
    alias: slider_45institutionsGiaC6pHVogMeta?.alias || [],
    redirect: slider_45institutionsGiaC6pHVogMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/widget/slider-institutions.vue").then(m => m.default || m)
  },
  {
    name: todas_45marcasYdRrSEdWaaMeta?.name ?? "widget-todas-marcas",
    path: todas_45marcasYdRrSEdWaaMeta?.path ?? "/widget/todas-marcas",
    children: [],
    meta: todas_45marcasYdRrSEdWaaMeta,
    alias: todas_45marcasYdRrSEdWaaMeta?.alias || [],
    redirect: todas_45marcasYdRrSEdWaaMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/widget/todas-marcas.vue").then(m => m.default || m)
  }
]